import { cn } from "@humanex/ui/libs";

interface SeparatorProps {
  color?: string;
  className?: string;
  direction?: "h" | "v";
}

export function Separator({ className, color = "primary-100", direction = "h" }: SeparatorProps) {
  return (
    <div
      className={cn(
        `border-${color}`,
        direction === "h" ? "h-0 w-full border-b" : "w-0 h-full border-r",
        className
      )}
    />
  );
}
